"use client";

import React from "react";

import { ErrorPage } from "@components/Errors/GlobalErrorPage.tsx";

export default function Error() {
  return (
    <div className="mx-auto w-full relative flex justify-center">
      <div className="md:max-w-(--home-container) ml-auto mr-auto w-full lg:px-4 mb-6 flex justify-center">
        <div className="flex flex-col lg:flex-row items-start justify-between gap-12 lg:mt-5">
          <div className="mb-10 overflow-hidden w-full lg:w-188">
            <ErrorPage />
          </div>
        </div>
      </div>
    </div>
  );
}
